import { render } from "./ShopFooter.vue?vue&type=template&id=0c3f557a&ts=true"
import script from "./ShopFooter.vue?vue&type=script&lang=ts"
export * from "./ShopFooter.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__